export const TABLET_MODE_MAX_WIDTH = 1248;
export const PHONE_MODE_MAX_WIDTH = 500;
export const DESKTOP_MODE_MIN_WIDTH = 1249;
export const BIG_SCREEN_MODE_MIN_WIDTH = 1824;
